import React from 'react';
import { CheckCircle } from 'lucide-react';
export function ValueOffer() {
  const includes = ['Más de 15 recetas exclusivas de postres en vaso', 'Videos paso a paso fáciles de seguir', 'Lista de ingredientes y proveedores recomendados', 'Guía de costos y precios de venta', 'Tips de presentación profesional', 'Estrategias de venta por redes sociales', 'BONUS: Plantillas para redes sociales', 'BONUS: Calculadora de costos y ganancias'];
  const handleCheckout = () => {
    window.location.href = 'https://productosdigitalesnuevos.myshopify.com/checkouts/cn/hWN9n9b8dLQ0zWcM4lh6BQg6/es-ar?_r=AQAB3sxDrVfYMB8G5oC3KtOEXxVl3WNVcpKRPbVzMknQ1i0&cart_link_id=QdC5wTSR&preview_theme_id=146146721979';
  };
  return <section className="py-20 bg-gradient-to-b from-[#140e0a] to-[#0d0906]" data-id="element-195">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-196">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-197">
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-198">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-199">
              ¿Qué <span className="text-[#d4a843]" data-id="element-200">incluye</span> el curso?
            </h2>

            <ul className="space-y-4 mb-10" data-id="element-201">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-202">
                  <CheckCircle className="w-6 h-6 text-[#d4a843] shrink-0 mt-0.5" data-id="element-203" />
                  <span className={`text-lg ${item.startsWith('BONUS') ? 'text-[#f0c14b] font-semibold' : 'text-[#c9b99a]'}`} data-id="element-204">
                    {item}
                  </span>
                </li>)}
            </ul>

            <button onClick={handleCheckout} className="btn-gold w-full sm:w-auto" data-id="element-205">
              Sí, Quiero Todo Esto
            </button>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-206">
            <div className="relative rounded-2xl overflow-hidden border border-[#d4a843]/20 shadow-[0_0_40px_rgba(212,168,67,0.2)]" data-id="element-207">
              <img src="https://cdn.magicpatterns.com/uploads/rrRuNoyZcXU5KXcHL9zax3/ChatGPT_Image_11_mar_2026,_12_11_21_a.m..png" alt="Preparación de postres" className="w-full h-auto object-cover" data-id="element-208" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0906] via-transparent to-transparent opacity-40" data-id="element-209"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}